// Force module refresh
import { DollarSign } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import type { EventoStats, PagamentosPorMetodo, MetodoPagamento, EventoDetalhe } from '../types'
import { METODO_PAGAMENTO_LABEL } from '../constants'
import { formatCurrency } from '@/lib/utils'

interface FinanceSummaryCardProps {
  stats: EventoStats
  pagamentosPorMetodo: PagamentosPorMetodo
  evento: EventoDetalhe
}

export function FinanceSummaryCard({ stats, pagamentosPorMetodo, evento }: FinanceSummaryCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <DollarSign className="h-5 w-5 text-primary" />
          Pagamentos
        </CardTitle>
        <CardDescription>Receitas e pendências por método</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="rounded-lg bg-emerald-500/10 p-3">
          <p className="text-xs text-muted-foreground">Receita recebida</p>
          <p className="text-2xl font-semibold text-emerald-600">
            {formatCurrency(stats.receitaRecebida)}
          </p>
        </div>
        <div className="grid gap-3 text-sm">
          <div className="flex items-center justify-between rounded-lg border p-3">
            <span className="text-muted-foreground">Receita prevista</span>
            <span className="font-semibold">{formatCurrency(stats.receitaPrevista)}</span>
          </div>
          <div className="flex items-center justify-between rounded-lg border p-3">
            <span className="text-muted-foreground">Em aberto</span>
            <span className="font-semibold text-amber-600">
              {formatCurrency(stats.receitaPendente)}
            </span>
          </div>
        </div>
        <Separator />
        <div className="space-y-3">
          {evento.chave_pix && (
            <div className="rounded-lg border bg-muted/50 p-3">
              <h4 className="font-medium">Pagar com Pix</h4>
              <p className="text-sm text-muted-foreground">
                Chave aleatória:{' '}
                <span className="font-mono">{evento.chave_pix}</span>
              </p>
            </div>
          )}
          {Object.keys(pagamentosPorMetodo).length === 0 && (
            <p className="text-sm text-muted-foreground">
              Nenhum pagamento confirmado até o momento.
            </p>
          )}
          {Object.entries(pagamentosPorMetodo).map(([metodo, dados]) => (
            <div key={metodo} className="rounded-lg bg-muted/60 p-3 text-sm">
              <p className="font-medium">
                {METODO_PAGAMENTO_LABEL[metodo as MetodoPagamento] ?? metodo}
              </p>
              <p className="text-xs text-muted-foreground">
                {dados.quantidade} pagamento(s) • {formatCurrency(dados.total)}
              </p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
